import {
  type AiGeneratedBookCover,
  type Caption,
  type Cover,
  type DesignedCover,
  PageSide,
  type PhotoCover,
} from './PhotoBook.types'

// Which side of a sheet faces the reader: everything before the open spread has
// been flipped over, so its back is showing.
export function getPageSide(
  pageIndex: number,
  currentPageIndex: number
): PageSide {
  return pageIndex < currentPageIndex ? PageSide.BACK : PageSide.FRONT
}

export function isPhotoCover(
  cover: Cover | null | undefined
): cover is PhotoCover {
  return cover?.type === 'photo'
}

export function isDesignedCover(
  cover: Cover | null | undefined
): cover is DesignedCover {
  return cover?.type === 'designed'
}

export function isAiGeneratedCover(
  cover: Cover | null | undefined
): cover is AiGeneratedBookCover {
  return cover?.type === 'ai-generated'
}

export function getBookCaption(cover: Cover): Caption {
  return isAiGeneratedCover(cover) ? cover.bookCaption : cover.caption
}
